exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-container[data-v-00ef1899] {\n  width: 100%;\n  min-height: 80vh;\n}\n.breadcrumb[data-v-00ef1899] {\n  margin-bottom: 20px;\n  font-size: 16px;\n  cursor: pointer;\n}\n.action-detail[data-v-00ef1899] {\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n", ""]);

// exports
